(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"), require("ProtvistaUtils"));
	else if(typeof define === 'function' && define.amd)
		define(["d3", "ProtvistaUtils"], factory);
	else if(typeof exports === 'object')
		exports["ProtvistaNavigation"] = factory(require("d3"), require("ProtvistaUtils"));
	else
		root["ProtvistaNavigation"] = factory(root["d3"], root["ProtvistaUtils"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__8__) {
return 